import { useRenderFilterContent } from '@aibees/elephant/feature/search-filters/hooks/use-render-filter-content';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import { EmployeeByDepartmentItemFilterInputError } from '../employee-by-department-item-filter-input-error';
import * as SX from './sx';
import type { EmployeeByDepartmentItemFilterInputProps as Props } from './types';

export const EmployeeByDepartmentItemFilterInput = memo(
  ({
    className,
    filter,
    onChange,
    value,
    error,
    parentField,
    onClearButtonClick,
    showClearButton,
    onClear,
  }: Props) => {
    const content = useRenderFilterContent([filter], true, filter.sections, {
      onChange,
      value,
      error,
      parentField,
      onClearButtonClick,
      showClearButton,
      onClear,
    });
    return (
      <Box
        className={classnames('EmployeeByDepartmentItemFilterInput', className)}
        display="flex"
        flexDirection="column"
        sx={SX.root}
      >
        {content}
        <EmployeeByDepartmentItemFilterInputError
          value={value}
          field={filter.field!}
          show={error}
        />
      </Box>
    );
  }
);

EmployeeByDepartmentItemFilterInput.displayName =
  'EmployeeByDepartmentItemFilterInput';
